import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TableDeleteColumn = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 28 28"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 25.25v-7.73l.08-.07.67-.67.67.67.08.07v7.73a.75.75 0 0 1-1.5 0Zm.08-14.45a1.83 1.83 0 0 0-.08-.07V2.75a.75.75 0 0 1 1.5 0v7.98l-.08.07-.67.67-.67-.67Zm-1.86 4.67a.75.75 0 1 0 1.06 1.06L14 15.06l1.47 1.47a.75.75 0 1 0 1.06-1.06L15.06 14l1.47-1.47a.75.75 0 1 0-1.06-1.06L14 12.94l-1.47-1.47a.75.75 0 1 0-1.06 1.06L12.94 14l-1.47 1.47ZM3.75 3a.75.75 0 0 0 0 1.5h1.5c1.24 0 2.25 1 2.25 2.25V9.5H3.75a.75.75 0 0 0 0 1.5H7.5v6H3.75a.75.75 0 0 0 0 1.5H7.5v2.75c0 1.24-1 2.25-2.25 2.25h-1.5a.75.75 0 0 0 0 1.5h1.5A3.75 3.75 0 0 0 9 21.25V6.75A3.75 3.75 0 0 0 5.25 3h-1.5Zm19 0A3.75 3.75 0 0 0 19 6.75v14.5A3.75 3.75 0 0 0 22.75 25h2.5a.75.75 0 0 0 0-1.5h-2.5c-1.24 0-2.25-1-2.25-2.25V18.5h4.75a.75.75 0 0 0 0-1.5H20.5v-6h4.75a.75.75 0 0 0 0-1.5H20.5V6.75c0-1.24 1-2.25 2.25-2.25h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
  }));
});
TableDeleteColumn.displayName = 'TableDeleteColumn';
export var TableDeleteColumnDimensions = {
  height: 28,
  width: 28
};